import Icon from '@ant-design/icons'
import styled from "styled-components";
import { LoadingIcon } from '../../constants/cssElements';
import allIcons from "../../constants/svgIcon";

interface Props {
    title?: React.ReactNode;
    style?: object;
    background: string;
    fontsize: number;
    color: string;
    loading: string;
    type: "submit" | "button" | "reset";
    method?: () => void;
    disabled?: boolean;
    classname?:any;
}

const ButtonStyled = styled.button<Props>`
    background: ${(props) => props.background};
    font-size: ${(props) => props.fontsize + 'px'};
    padding: 10px;
    border: 0;
    font-weight: bolder;
    border-radius: 5px;
    width: 100%;
    color: ${(props) => props.color};
    display: flex;
    justify-content: center;
    align-items: center;
    ${(props) => props.loading === 'true' && {
        opacity: 0.8,
    }}

    ${(props) => props.disabled?.toString() === 'true' && {
        
        opacity: 0.6,
        
        
    }}
      ${(props) => props.disabled?.toString() === 'true'? `{ cursor: default}` : `{ cursor: pointer}`}
   
   

    ${(props) => props.disabled?.toString() === 'false' && `
        :active {
            opacity: 0.8;
        }
    `
    }
`;

const LoadingButton = ({ title,classname, background, fontsize, color, method, loading, type, style, disabled = false }: Props): JSX.Element => {
    return (
        <ButtonStyled
            type={type}
            disabled={disabled}
            loading={loading}
            onClick={!!method ? method : undefined}
            background={background}
            fontsize={fontsize}
            color={color}
            style={style}
            className={classname}
        >
            {loading === 'true'
                ? <LoadingIcon className='loading-icon' color={color} size={'1.2em'} />
                : title
            }
        </ButtonStyled>

    )
}


export default LoadingButton;